import type { BaggageFuelEconomyPayload } from '@makemydeal/dr-dash-bff-types';

import { SET_BAGGAGE_FUEL_ECONOMY } from '../actionTypes/baggageFuelEconomyActionTypes';

export const setBaggageFuelEconomy = (payload: BaggageFuelEconomyPayload) => ({
    type: SET_BAGGAGE_FUEL_ECONOMY,
    payload
});
